// extracted by mini-css-extract-plugin
export const heading = "heading-module--heading--vI1IS";